
const FormatDate = ({ date, showTime = false }) => {
  if (!date) return <span>-</span>;

  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let formattedDate = `${day}-${month}-${year}`;

  if (showTime) {
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    formattedDate += ` à ${hours}:${minutes}`;
  }

  return <span>{formattedDate}</span>;
};

export default FormatDate;
